const TYPE = {
	ELECTION_PARAMETERS_TYPE: 'election_parameters_type',
	ELECTION_PARAMETERS_TYPE_CREATE: 'election_parameters_type_create',
	ELECTION_PARAMETERS_TYPE_EDIT: 'election_parameters_type_edit',
	ELECTION_PARAMETERS_TYPE_DELETE: 'election_parameters_type_delete',
} as const;

const CATEGORY = {
	ELECTION_PARAMETERS_CATEGORY: 'election_parameters_category',
} as const;

const ATTRIBUTES = {
	ELECTION_PARAMETERS_ATTRIBUTES: 'election_parameters_attributes',
	ELECTION_PARAMETERS_ATTRIBUTES_CREATE: 'election_parameters_attributes_create',
	ELECTION_PARAMETERS_ATTRIBUTES_EDIT: 'election_parameters_attributes_edit',
	ELECTION_PARAMETERS_ATTRIBUTES_DELETE: 'election_parameters_attributes_delete',
} as const;

/**
 * Which parties are on an Election Attribute's ballot, and any election's narrowed list.
 * Seeded by api.core's `PermissionBootstrapHostedService` (admin roles) once the backend ships
 * `ActionKeys.ElectionParticipantsManage` — until then, and until a re-login, it gates every
 * write control closed while the read views stay open.
 */
const PARTICIPANTS = {
	ELECTION_PARTICIPANTS_MANAGE: 'election_participants_manage',
} as const;

export const ACTIONS_ELECTION_PARAMETERS = {
	ELECTION_PARAMETERS: 'election_parameters',
	...TYPE,
	...CATEGORY,
	...ATTRIBUTES,
	...PARTICIPANTS,
} as const;
